<script setup>

//properties set by parent
const props = defineProps({
	dim: {
		type: Object,
		required: true,
	}
})	

//events raised by component
const emit = defineEmits(['filterItem'])

//Reactive field proxies


//Methods
const openFilterItem = () => {
	emit('filterItem', props.dim)
}

//Reactive computed field
const getSubTitle = ()=>{
	//console.log(props.dim)
	const selected = props.dim.appliedValues.filter(x => {
		return x.selected // && x.visible
	})
	if(selected.length == 1)
		return selected[0].name
	else 
		return `${selected.length} selected` 
}
</script>

<template>
	<button class="filter-item" @click="openFilterItem" >
		<div>
			<div class="filter-title">
				{{props.dim.columnName}}
			</div>
			<div class="filter-text">
				{{getSubTitle()}}
			</div>
		</div>
		<div class=" btn-arrow">
			<i class="fa-solid fa-xs fa-chevron-right"></i>
		</div>
	</button>
</template>

<style scoped>

.filter-item {
	display: flex;
	height: 4.1875rem;
	align-self: stretch;
	align-items: center;
	justify-content: space-between;
	border: 0;
	border-bottom: 1px solid var(--border-color-Divider, #A9B7C7);
	width:22rem;
	border-radius: 0;
	background-color: var(--surface-color-Default);
}

.filter-item:hover {
	text-decoration: none;
}

.filter-title {
	color: var(--text-Primary, #2C2C2C);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */
	text-align: left;
}

.filter-text {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;

	overflow: hidden;
	color: var(--text-Secondary, #757575);
	text-overflow: ellipsis;
	text-align: left;

	/* Regular/Caption */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Caption, 0.875rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Caption, 1.25rem); /* 142.857% */
	text-transform: uppercase;	
}

.btn-arrow {
	/* chevron-right */

	color: var(--icon-cta-blue, #064291);
	text-align: center;
	/* font-family: "Font Awesome 6 Pro"; */
	font-size: 1rem;
	font-style: normal;
	font-weight: 900;
	line-height: normal;
	min-width: 0;
}

.disabled {
	color: var(--brand-color-PaleGrey);
}
</style>
